module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-640.e1a81a14.jpg";